import { Organization } from 'interfaces/organization';
import { MRT_ColumnDef } from 'mantine-react-table';

export const OrganizationColumns = () => {
  const columns: MRT_ColumnDef<Organization>[] = [
    {
      accessorKey: 'name',
      header: 'Name',
      mantineEditTextInputProps: () => ({
        placeholder: 'Name',
        required: true,
        'data-testid': 'organizationNameTextInput',
      }),
    },
    {
      accessorKey: 'address',
      header: 'Address',
      mantineEditTextInputProps: () => ({
        placeholder: 'address',
        required: true,

        'data-testid': 'organizationAddressTextInput',
      }),
    },
    {
      accessorKey: 'city',
      header: 'City',
      mantineEditTextInputProps: () => ({
        placeholder: 'city',
        required: true,
        'data-testid': 'organizationCityTextInput',
      }),
    },
    {
      accessorKey: 'province',
      header: 'Province',
      accessorFn: (row) => row.province,
      mantineEditSelectProps: () => ({
        data: [
          { value: 'AB', label: 'Alberta' },
          { value: 'BC', label: 'British Columbia' },
          { value: 'MB', label: 'Manitoba' },
          { value: 'NB', label: 'New Brunswick' },
          { value: 'NL', label: 'Newfoundland and Labrador' },
          { value: 'NS', label: 'Nova Scotia' },
          { value: 'ON', label: 'Ontario' },
          { value: 'PE', label: 'Prince Edward Island' },
          { value: 'QC', label: 'Quebec' },
          { value: 'SK', label: 'Saskatchewan' },
          { value: 'NT', label: 'Northwest Territories' },
          { value: 'NU', label: 'Nunavut' },
          { value: 'YT', label: 'Yukon' },
        ],
        placeholder: 'province',
        required: true,
        'data-testid': 'organizationProvinceTextInput',
      }),
      editVariant: 'select',
    },
  ];
  return columns;
};
